import { useEffect, useState } from "react";
import useApi from "../../../helpers/apiHelper/requestHelper";
import dropdownAngle from "../../../assets/images/dropdownAngle.svg";
import plusIcon from "../../../assets/images/plusIcon.svg";
import { useParams } from "react-router-dom";
import DisplayModal from "./DisplayModal.jsx";
import arrow from "../../../assets/images/rightAnglePath.svg";
import noDataIcon from "../../../assets/images/noDataIcon.svg";
import { useNavigate } from "react-router-dom";
import "./viewSearchVerifiedTrade.css";
import DisplayModalForTrader from "../../VerifyMyTrade/LeaderVerifiedTrades/DisplayModal.jsx";
import DisplayModalForCommunity from "../../PublicVerifiedTrade/viewSearchVerifiedTrade/DisplayModal.jsx";

const VerifiedTradeView = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const handleDropdownToggle = () => setIsOpen((prevState) => !prevState);
  const api = useApi();
  const { id } = useParams();
  const [trade, setTrade] = useState(null);
  const navigate = useNavigate();
  // const columns = [
  //   "Trader name",
  //   "Date",
  //   "Time",
  //   "Asset",
  //   "Blockchain Transaction ID",
  //   "Blockchain Link",
  // ];

  const columns = [
    {
      title: "Trader Name",
      width: 170,
    },
    {
      title: "Date",
      width: 110,
    },
    {
      title: "Time",
      width: 150,
    },
    {
      title: "Asset",
      width: 170,
    },
    {
      title: "Blockchain Transaction ID",
      width: 350,
    },
    {
      title: "Blockchain Link",
      width: 120,
    },
  ];

  useEffect(() => {
    api("get", `/blockchain/getTrade/${id}`).then((res) => {

      if (res.status) {
        setTrade(res.data.trade);
        setLoading(false);
      }
    });
  }, [id]);
  function formatBackendDate(isoString) {
    const date = new Date(isoString); // parses the ISO string
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();

    return `${day}-${month}-${year}`;
  }
  function formatTimeWithUTCOffset(isoString) {
    const date = new Date(isoString);

    // Get local time components
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    // Get time zone offset in minutes and convert to hours
    const timezoneOffsetMinutes = -date.getTimezoneOffset(); // reverse the sign
    const timezoneOffsetHours = timezoneOffsetMinutes / 60;
    const sign = timezoneOffsetHours >= 0 ? "+" : "-";

    return `${hours}:${minutes}:${seconds} UTC${sign}${Math.abs(
      timezoneOffsetHours
    )}`;
  }
  // if (!trade) return;

  if (loading) {
    return (
      <div className="loadingWrapper">
        <div className="loading-4">
          <span className="span1"></span>
          <span className="span2"></span>
          <span className="span3"></span>
        </div>
      </div>
    );
  }

  // if (!trade && !loading)
  //   return (
  //     <div className="no-content" style={{ marginTop: "125px" }}>
  //       <h3 className="text-center">No verified trade yet</h3>
  //     </div>
  //   );

  return (
    <div className="custom-container">
      <div
        className={`verifyBlockchainTradesDetailPage ${
          !trade && !loading && "verifyTradesDetailPageNoData"
        }`}
      >
        <button
          onClick={() => {
            navigate("/verifymytrades");
          }}
          className="backTOTheSearch"
        >
          <img src={arrow} className="angleLeft" alt="Arrow" />
          Back to Search
        </button>
        <div className="verifyBlockchainTradesWrapper">
          <div className="publicVerifiedTradesTableWrap d-md-block d-none">
            <table className="publicVerifiedTradesTable">
              <thead>
                <tr>
                  <th></th>
                  {columns.map((col) => (
                    <th
                      key={col}
                      style={{ whiteSpace: "nowrap", width: col.width }}
                    >
                      {col.title}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {(!trade && !loading) && (
                <tr>
                  <td colSpan="7">
                    <div className="noDataTable">
                      <img src={noDataIcon} alt="noDataIcon" />
                      <h3 className="text-center">No verified trades yet</h3>
                    </div>
                  </td>
                </tr>
                )}
                <tr key={trade._id}>
                  <td>
                    {trade.statsSnapshot?.orders?.length > 0 && (
                      <div className="totalNumOfTrades">
                        <img alt="plusIcon" src={plusIcon} />
                        {trade.statsSnapshot.orders.length}
                      </div>
                    )}
                  </td>
                  <td
                    style={{ width: "200px" }}
                    className="tradeStatsSnapshot"
                    onClick={() => {
                      setShow(true);
                    }}
                  >
                    {trade.statsSnapshot?.name?.split("_")[0]}
                  </td>
                  <td style={{ width: "100px" }}>
                    {formatBackendDate(trade.createdAt)}
                    {/* {new Date(trade.createdAt).toLocaleDateString()} */}
                    {isOpen && (
                      <div className="tableDropdownContent">
                        {trade.statsSnapshot?.orders?.map((option, index) => (
                          <p
                            className="table-dropdown-option position-relative"
                            key={index}
                          >
                            {formatBackendDate(trade.createdAt)}
                          </p>
                        ))}
                      </div>
                    )}
                  </td>
                  <td style={{ width: "200px" }}>
                    {/* {new Date(trade.createdAt).toLocaleTimeString()} */}
                    {formatTimeWithUTCOffset(trade.createdAt)}
                    {isOpen && (
                      <div className="tableDropdownContent">
                        {trade.statsSnapshot?.orders?.map((option, index) => (
                          <p
                            className="table-dropdown-option position-relative"
                            key={index}
                          >
                            {formatTimeWithUTCOffset(trade.createdAt)}
                          </p>
                        ))}
                      </div>
                    )}
                  </td>
                  {/* <td style={{ padding: "8px" }}>{trade.totalPnl}</td> */}
                  <td style={{ width: "170px" }}>
                    <div
                      className="assertColumn"
                      onClick={() => {
                        if (trade?.statsSnapshot?.orders?.length > 1) {
                          handleDropdownToggle();
                        }
                      }}
                    >
                      <button
                        className={`tableDropdownButton`}
                        style={{ marginBottom: isOpen ? 0 : 5 }}
                        // ref={buttonRef}
                        // disabled={disabled}
                      >
                        <span className={`selectedOption `}>
                        {/* {trade?.statsSnapshot?.orders?.length > 1 ?  "SATS1000X/USDT":`${trade?.statsSnapshot?.orders[0]?.coinName?.split("USDT").join("/USDT")}`} */}
                        {trade?.statsSnapshot?.orders?.length && trade?.statsSnapshot?.orders?.length > 1
                              ? "Multiple Trades"
                              : trade?.statsSnapshot?.orders?.length && trade?.statsSnapshot?.orders?.length === 1
                              ? `${trade?.statsSnapshot?.orders[0]?.coinName?.split("USDT").join("/USDT")}`
                              : trade?.type}
                        </span>
                        <span
                          className={`dropdownArrow ${isOpen && "rotate"}`}
                          style={{ opacity: 1 }}
                        >
                          {trade?.statsSnapshot?.orders?.length > 1 && (
                            <img alt="dropdownAngle" src={dropdownAngle} />
                          )}
                        </span>
                      </button>
                      {!isOpen && trade?.statsSnapshot?.orders?.length > 1 && (
                        <span className={`clickForSelectText `}>
                          CLICK TO SEE TRADES
                        </span>
                      )}
                      {isOpen && (
                        <div className="tableDropdownContent">
                          {trade?.statsSnapshot?.orders?.map((option, index) => (
                            <p
                              className="table-dropdown-option position-relative"
                              key={index}
                            >
                              {option?.coinName}
                            </p>
                          ))}
                        </div>
                      )}
                    </div>
                  </td>
                  <td style={{ width: "370px" }}>
                    {trade.blockChainId}

                    {isOpen && (
                      <div className="tableDropdownContent">
                        {trade.statsSnapshot?.orders?.map((option, index) => (
                          <p
                            className="table-dropdown-option position-relative"
                            key={index}
                          >
                            {trade.blockChainId}
                          </p>
                        ))}
                      </div>
                    )}
                  </td>
                  <td>
                    <a
                      href={trade.blockChainLink}
                      className="blockchainTradeLink"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* Mobile View */}
          <div className="verifyBlockchainTradesMobileViewWrap d-md-none b-block">
            {(!trade && !loading) && (
            <div className="noDataTable">
              <img src={noDataIcon} alt="noDataIcon" />
              <h3 className="text-center">No verified trades yet</h3>
            </div>
             )}
            <div className="tradeNameAndDurationWrap d-flex justify-content-between flex-wrap">
              <div className="traderNameWrap d-flex align-items-center">
                {trade.statsSnapshot?.orders?.length > 0 && (
                  <div className="totalNumOfTrades">
                    <img alt="plusIcon" src={plusIcon} />
                    {trade.statsSnapshot?.orders?.length}
                  </div>
                )}
                <p>{trade.statsSnapshot?.name}</p>
              </div>

              <div className="dateAndTimeWrapper">
                <p className="blockDate">
                  {formatBackendDate(trade.createdAt)}
                </p>
                <p>{formatTimeWithUTCOffset(trade.createdAt)}</p>
              </div>
            </div>
            <div className="blockchainIdWrapper">
              <h6>Blockchain Transaction ID</h6>
              <p style={{ wordBreak: "break-all" }}>{trade.blockChainId}</p>
            </div>
            <div className="blockchainDropdownWrapper">
              <div className="assertColumn" onClick={handleDropdownToggle}>
                <button
                  className={`tableDropdownButton`}
                  style={{ marginBottom: isOpen ? 0 : 5 }}
                  // ref={buttonRef}
                  // disabled={disabled}
                >
                  <span className={`selectedOption `}>SATS1000X/USDT</span>
                  <span
                    className={`dropdownArrow ${isOpen && "rotate"}`}
                    style={{ opacity: 1 }}
                  >
                    <img alt="dropdownAngle" src={dropdownAngle} />
                  </span>
                </button>
                {!isOpen && (
                  <span className={`clickForSelectText `}>
                    CLICK TO SEE TRADES
                  </span>
                )}
                {isOpen && (
                  <div className="tableDropdownContent">
                    {trade.statsSnapshot?.orders?.map((option, index) => (
                      <p
                        className="table-dropdown-option position-relative"
                        key={index}
                      >
                        {option.coinName}
                      </p>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div className="blockchainLinkWrapper">
              <h6>Blockchain Link</h6>
              <a
                href={trade.blockChainLink}
                className="blockchainTradeLink"
                target="_blank"
                rel="noopener noreferrer"
              >
                View
              </a>
            </div>
          </div>

          {/* Mobile View */}
          {/* <div className="paginationWrapper">
            <TablePagination />
          </div> */}
        </div>
      </div>
       {/* {show && (
        <DisplayModal
          communityName={trade.statsSnapshot?.name?.split("_")[0]}
          showModal={show}
          setChangeShowModal={setShow}
          userId={trade?.refId}
        />
      )}  */}
       {show && trade && (
        <>
          {trade.tradeOf === "trader" ? (
            <DisplayModalForTrader
              displayName={trade.statsSnapshot?.name?.split("_")[0]}
              // displayName={selectedTrade.statsSnapshot.name.split("_")[0]}
              showModal={show}
              setChangeShowModal={setShow}
              traderId={trade.refId}
            />
          ) : (
            <DisplayModalForCommunity
              communityName={trade.statsSnapshot?.name?.split("_")[0]}
              showModal={show}
              setChangeShowModal={setShow}
              userId={trade.refId}
            />
          )}
        </>
      )}
    </div>
  );
};

export default VerifiedTradeView;
